import React, { useState } from "react";
import {
  EO_ACCESS_LEVELS,
  SOCIAL_MEDIA_ICONS,
} from "../../../constants/constants";

const accessLevels = EO_ACCESS_LEVELS;
const ModalEventShare = ({ handleClose, handleGoToDashboard }) => {
  const [contributors, setContributors] = useState([]);
  const [email, setEmail] = useState("");
  const [selectedAccessLevel, setSelectedAccessLevel] = useState(
    accessLevels[0]
  );
  const [selectedSocialMedia, setSelectedSocialMedia] = useState({
    instagram: "false",
    facebook: "false",
    twitter: "false",
    tiktok: "false",
    globe: "false",
  });
  const socialMediaIcons = SOCIAL_MEDIA_ICONS;

  const handleAddContributor = () => {
    if (email && !contributors.some((c) => c.email === email)) {
      setContributors([
        ...contributors,
        { email, accessLevel: selectedAccessLevel },
      ]);
      setEmail(""); // Reset email input
    }
  };

  const handleAccessLevelChange = (index, newLevel) => {
    const updatedContributors = [...contributors];
    updatedContributors[index].accessLevel = newLevel;
    setContributors(updatedContributors);
  };
  const handleSocialMediaChange = (socialProfile) => {
    setSelectedSocialMedia((prevState) => ({
      ...prevState,
      [socialProfile]: !prevState[socialProfile],
    }));
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-grey-25 bg-opacity-100">
      <div className="bg-white justify-center p-6 rounded-2xl shadow-lg max-w-md w-full">
        <div className="flex justify-center space-x-4">{/* Icon */}</div>
        <h2 className="justify-center text-center text-lg font-semibold mb-6 text-grey-900">
          Share Event
        </h2>
        {/* description */}
        <p className="mb-6 text-sm text-grey-600 text-center"></p>
        {/* Add Contributors Section */}
        <div className="mb-6">
          <h2 className="text-lg font-semibold mb-6 text-grey-900">
            Add Contributors
          </h2>
          <div className="flex items-center mt-2  border border-grey-300 rounded-lg">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 p-2 rounded-lg"
              placeholder="Invite people to contribute"
            />
            <select
              value={selectedAccessLevel}
              onChange={(e) => setSelectedAccessLevel(e.target.value)}
              className="p-2 rounded-lg"
            >
              {accessLevels.map((level) => (
                <option key={level} value={level}>
                  {level}
                </option>
              ))}
            </select>
            <button
              onClick={handleAddContributor}
              className="px-4 py-2 bg-grey-800 text-white rounded-lg hover:bg-grey-900"
            >
              Add
            </button>
          </div>
        </div>

        {/* List of Contributors */}
        <div className="mb-6">
          {contributors.map((contributor, index) => (
            <div
              key={index}
              className="flex items-center justify-between space-x-3 py-2 border-b"
            >
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center text-white">
                  {contributor.email.slice(0, 1).toUpperCase()}
                </div>
                <span className="text-grey-700">{contributor.email}</span>
              </div>
              <div>
                <select
                  value={contributor.accessLevel}
                  onChange={(e) =>
                    handleAccessLevelChange(index, e.target.value)
                  }
                  className="p-2 rounded-lg"
                >
                  {accessLevels.map((level) => (
                    <option key={level} value={level}>
                      {level}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ))}
        </div>

        {/* Share Section */}
        <div className="mb-6">
          <h2 className="text-lg font-semibold mb-6 text-grey-900">Share</h2>
          <h3 className="text-sm font-semibold text-grey-900 mb-2">
            Share to Social Media
          </h3>
          <p className="text-xs text-grey-600 mb-3">
            All your linked accounts will appear here. Tap each to share.
          </p>
          {/* <div className="flex space-x-4 text-4xl">
            <p
              className="text-grey-900"
              value={"instagram"}
              onClick={(e) => handleSocialMediaChange(e.target.value)}
            >
              <ion-icon name="logo-instagram"></ion-icon>
            </p>
            <p
              className="text-grey-900"
              value={"facebook"}
              onClick={(e) => handleSocialMediaChange(e.target.value)}
            >
              <ion-icon name="logo-facebook"></ion-icon>
            </p>
            <p
              className="text-grey-900"
              value={"tiktok"}
              onClick={(e) => handleSocialMediaChange(e.target.value)}
            >
              <ion-icon name="logo-tiktok"></ion-icon>
            </p>
            <p
              className="text-grey-900"
              value={"twitter"}
              onClick={(e) => handleSocialMediaChange(e.target.value)}
            >
              <ion-icon name="logo-twitter"></ion-icon>
            </p>
            <p
              className="text-grey-900"
              value={"globe"}
              onClick={(e) => handleSocialMediaChange(e.target.value)}
            >
              <ion-icon name="globe-outline"></ion-icon>
            </p>
          </div> */}
          <div className="flex space-x-4 text-4xl">
            {Object.keys(selectedSocialMedia).map((platform) => (
              <p
                key={platform}
                className={`${
                  selectedSocialMedia[platform]
                    ? "text-grey-900"
                    : "text-red-500"
                }`}
                onClick={() => handleSocialMediaChange(platform)}
              >
                <ion-icon name={socialMediaIcons[platform]}></ion-icon>
              </p>
            ))}
          </div>
        </div>
        <div className="flex relative justify-end space-x-4">
          <button
            className="bg-grey-25 hover:bg-grey-50 text-grey-900 font-semibold px-4 py-3 text-base rounded-lg border-2 "
            onClick={() => handleClose()}
          >
            Copy Link
          </button>
          <button
            className=" bg-grey-700 hover:bg-grey-800  text-grey-25 px-4 py-3 text-base font-semibold rounded-lg"
            onClick={() => {
              handleGoToDashboard();
            }}
          >
            Share
          </button>
        </div>
      </div>
    </div>
  );
};
export default ModalEventShare;
